import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUnileverComponent } from './simple-icons-unilever.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUnileverComponent ],
    exports:      [ SimpleIconsUnileverComponent ],
    bootstrap:    []
})
export class SimpleIconsUnileverModule {}
